
import { Button } from "@/components/ui/button";
import { useTheme } from "@/lib/theme/ThemeContext";

interface AddChildDialogFooterProps {
  onCancel: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  isDisabled: boolean;
}

export function AddChildDialogFooter({ 
  onCancel, 
  onSubmit, 
  isSubmitting, 
  isDisabled 
}: AddChildDialogFooterProps) {
  const isLightTheme = false;

  return (
    <div className="flex justify-end gap-3">
      <Button
        variant="outline"
        onClick={onCancel}
        className={
          isLightTheme 
            ? "bg-white border-slate-200 text-slate-700 hover:bg-slate-50 hover:text-slate-800" 
            : "bg-transparent border-gray-600 text-gray-200 hover:bg-gray-700 hover:text-white"
        }
      >
        Cancel
      </Button>
      <Button
        onClick={onSubmit}
        disabled={isDisabled || isSubmitting}
        className={
          isLightTheme 
            ? "bg-blue-primary text-white hover:bg-blue-600" 
            : "bg-[#9B87F5] text-white hover:bg-[#8A74F4]"
        }
      >
        {isSubmitting ? "Adding..." : "Add Child"}
      </Button>
    </div>
  );
}
